export const getGeneralError = state => state.appLoadingState.errorMsg;
export const getIsLoading = state => state.appLoadingState.isLoading;
